module.exports = __webpack_public_path__ + "img/home_slogan.84abe5dc.png";